import { getAccountScopeUserSettings } from 'owa-session-store';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Get the primary from email address, i.e. the address used to initially create the account
 */
export default function getPrimaryFromAddress(mailboxInfo: MailboxInfo): string {
    return getAccountScopeUserSettings(mailboxInfo).SessionSettings?.UserEmailAddress ?? '';
}
